export default __webpack_public_path__ + "img/owl-wing-open-right.0717013a.svg";